<template>
    <div class="card-body">
        <div><strong>{{ $translate("Ceres::Template.myAccountEmail") }}</strong></div>
        <div v-if="!!userData">{{ userData.email }}</div>
        <div><strong>{{ $translate("Ceres::Template.myAccountPassword") }}</strong></div>
        <div>***********</div>
        <div><strong>{{ $translate("OD3dprimaV2::Template.myAccountCustomerType") }}</strong></div>
        <div>
            {{ currentPriceType === 'b2b' ? $translate("OD3dprimaV2::Template.myAccountB2B")
                : $translate("OD3dprimaV2::Template.myAccountB2C") }}
        </div>
        <div class="add-item">
            <span v-if="isChangeMailRouteEnabled" class="item-edit d-block mb-2">
                <button v-tooltip data-toggle="tooltip" data-placement="top"
                        :title="$translate('Ceres::Template.myAccountChangeEmail')"
                        class="btn btn-primary btn-appearance btn-large btn-only-icon-xs-down"
                        @click="showChangeAccountEmail">
                    <span>{{ $translate("Ceres::Template.myAccountChangeEmail") }}</span>
                    <i class="fa fa-envelope" aria-hidden="true"></i>
                </button>
            </span>
            <span class="item-edit d-block mb-2">
                <button v-tooltip data-toggle="tooltip" data-placement="top"
                        :title="$translate('Ceres::Template.myAccountChangePassword')"
                        class="btn btn-primary btn-appearance btn-large btn-only-icon-xs-down"
                        @click="showChangeAccountPassword">
                    <span>{{ $translate("Ceres::Template.myAccountChangePassword") }}</span>
                    <i class="fa fa-lock fa-lg" aria-hidden="true"></i>
                </button>
            </span>
            <span class="item-edit d-block">
                <button v-tooltip data-toggle="tooltip" data-placement="top"
                        :title="$translate('OD3dprimaV2::Template.myAccountChangeTypeTooltip')"
                        class="btn btn-primary btn-appearance btn-large btn-only-icon-xs-down"
                        @click="showChangeCustomerType">
                    <span>{{ $translate("OD3dprimaV2::Template.myAccountChangeType") }}</span>
                    <i class="fa fa-lock fa-lg" aria-hidden="true"></i>
                </button>
            </span>
        </div>
        <div v-if="isChangeMailRouteEnabled" ref="accountEmailModal">
            <div class="modal fade">
                <div class="modal-dialog" role="document">
                    <form class="modal-content" method="post" @submit.prevent>
                        <div class="modal-header">
                            <h4 class="modal-title">{{ $translate("Ceres::Template.myAccountChangeEmail") }}</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="clearFields">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body form-horizontal">
                            <div class="row">
                                <div class="col-12">
                                    <div class="input-unit">
                                        <input type="email" id="newMail" name="newMail" autocomplete="off" v-model="newMail" data-autofocus>
                                        <label for="newMail">{{ $translate("Ceres::Template.myAccountNewEmail") }}</label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="input-unit no-bottom">
                                        <input type="email" id="newMail2" name="newMail2" autocomplete="off" v-model="newMail2">
                                        <label for="newMail2">{{ $translate("Ceres::Template.myAccountRepeatEmail") }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div v-show="!matchEmail" class="text-danger">
                                        {{ $translate("Ceres::Template.myAccountCorrectEmail") }}
                                    </div>
                                    <div v-show="matchOldEmail" class="text-danger">
                                        {{ $translate("Ceres::Template.myAccountOldEmail") }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary btn-appearance btn-block"
                                    @click="saveAccountEmail" :class="{'disabled': !isValidEmail || isLoading}">
                                <i class="fa fa-check" aria-hidden="true"></i>
                                <span>{{ $translate("Ceres::Template.myAccountSave") }}</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div ref="accountPasswordModal">
            <div class="modal fade">
                <div class="modal-dialog" role="document">
                    <form class="modal-content" method="post" @submit.prevent>
                        <div class="modal-header">
                            <h4 class="modal-title">{{ $translate("Ceres::Template.myAccountChangePassword") }}</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="clearFields">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body form-horizontal">
                            <div class="row">
                                <div class="col-12">
                                    <div class="input-unit">
                                        <input type="password" id="old_password" name="old_password" autocomplete="old-password"
                                               v-model="oldPassword" data-autofocus>
                                        <label for="old_password">{{ $translate("Ceres::Template.myAccountOldPassword") }}</label>
                                    </div>
                                </div>
                                <div class="col-12" ref="passwordFormControl">
                                    <div class="input-unit" data-validate="password">
                                        <popper v-cloak trigger="focus" placement="bottom" ref="passwordHint">
                                            <template #handle>
                                                <input type="password" :id="_uid" name="password"
                                                       autocomplete="new-password" v-model="newPassword">
                                            </template>
                                            <template #title>
                                                <div>
                                                    {{ $translate("Ceres::Template.regPasswordHintTitle") }}
                                                </div>
                                            </template>
                                            <template #content>
                                                <ul class="pl-3">
                                                    <li>{{ $translate("Ceres::Template.regPasswordHintLength") }}</li>
                                                    <li>{{ $translate("Ceres::Template.regPasswordHintDigit") }}</li>
                                                    <li>{{ $translate("Ceres::Template.regPasswordHintChar") }}</li>
                                                </ul>
                                            </template>
                                        </popper>
                                        <label :for="_uid">{{ $translate("Ceres::Template.myAccountNewPassword") }}</label>
                                    </div>
                                    <div class="input-unit" data-validate="password">
                                        <input type="password" :id="_uid+'-pwd_repeat'" name="password"
                                               autocomplete="new-password" v-model="confirmPassword">
                                        <label :for="_uid+'-pwd_repeat'">
                                            {{ $translate("Ceres::Template.myAccountRepeatPassword") }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div v-show="!matchPassword" class="text-danger">
                                        {{ $translate("Ceres::Template.myAccountCorrectPassword") }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary btn-appearance btn-block"
                                    @click="validatePassword" :class="{'disabled': !isValidPassword || isLoading}">
                                <i class="fa fa-check" aria-hidden="true"></i>
                                <span>{{ $translate("Ceres::Template.myAccountSave") }}</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div ref="accountCustomerTypeModal">
            <div class="modal fade">
                <div class="modal-dialog" role="document">
                    <form class="modal-content" method="post" @submit.prevent>
                        <div class="modal-header">
                            <h4 class="modal-title">
                                {{ $translate("OD3dprimaV2::Template.myAccountChangeType") }}
                            </h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="clearFields">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body form-horizontal">
                            <div class="row">
                                <div class="col-12" ref="typeFormControl" v-if="$data._billingAddress">
                                    <template v-if="currentPriceType === 'b2c'">
                                        <div class="my-account__type-hint mb-4">
                                            {{ $translate("OD3dprimaV2::Template.addressChangeB2B") }}
                                        </div>
                                        <div class="input-unit" data-validate="text">
                                            <input type="text" id="company" name="company" v-model="$data._billingAddress.name1" data-autofocus>
                                            <label for="company">{{ $translate("Ceres::Template.addressCompany") }}*</label>
                                        </div>
                                        <div class="input-unit" v-validate:text="requiredAddressFields.includes('billing_address.vatNumber')">
                                            <input type="text" id="vat_number" name="vat_number" v-model="$data._billingAddress.vatNumber">
                                            <label for="vat_number">
                                                {{ $translate("Ceres::Template.addressVatNumber") }}
                                                {{ requiredAddressFields.includes("billing_address.vatNumber") ? '*' : '' }}
                                            </label>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="my-account__type-hint mb-4">
                                            {{ $translate("OD3dprimaV2::Template.addressChangeB2C") }}
                                        </div>
                                        <div class="input-unit" data-validate="text">
                                            <input type="text" id="first_name" name="first_name" v-model="$data._billingAddress.name2" data-autofocus>
                                            <label for="first_name">{{ $translate("Ceres::Template.addressFirstName") }}*</label>
                                        </div>
                                        <div class="input-unit" data-validate="text">
                                            <input type="text" id="last_name" name="last_name" v-model="$data._billingAddress.name3">
                                            <label for="last_name">{{ $translate("Ceres::Template.addressLastName") }}*</label>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary btn-appearance btn-block"
                                    @click="validateCustomerType" :class="{'disabled': isLoading}" :disabled="isLoading">
                                <i class="fa fa-check" aria-hidden="true"></i>
                                <span>{{ $translate("Ceres::Template.myAccountSave") }}</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

const ModalService = require("ceres/app/services/ModalService");
const APIService = require("ceres/app/services/ApiService");
const NotificationService = require("ceres/app/services/NotificationService");
const ValidationService = require("ceres/app/services/ValidationService");

import TranslationService from "ceres/app/services/TranslationService";
import {isNullOrUndefined} from "ceres/app/helper/utils";

export default {

    props: {
        template:
        {
            type: String,
            default: "#vue-account-settings"
        },
        userData:
        {
            type: Object,
            // eslint-disable-next-line
            default: () => {}
        },
        enabledRoutes:
        {
            type: Array,
            default: () => []
        }
    },

    data()
    {
        return {
            isLoading           : false,
            oldPassword         : "",
            newPassword         : "",
            confirmPassword     : "",
            newMail             : "",
            newMail2            : "",
            accountSettingsClass: "",
            accountEmailModal: null,
            accountPasswordModal: {},
            accountCustomerTypeModal: {},
            _billingAddress: null,
            requiredAddressFields: App.config.addresses.billingAddressRequire
        };
    },

    /**
     * Initialise the account settings modal
     */
    mounted()
    {
        this.$nextTick(() =>
        {
            if (this.$refs.accountEmailModal)
            {
                this.accountEmailModal = ModalService.findModal(this.$refs.accountEmailModal);
            }

            this.accountPasswordModal = ModalService.findModal(this.$refs.accountPasswordModal);
            this.accountCustomerTypeModal = ModalService.findModal(this.$refs.accountCustomerTypeModal);
        });
    },

    computed: {
        matchEmail()
        {
            return this.newMail2.length <= 0 || this.newMail === this.newMail2;
        },
        matchOldEmail()
        {
            return this.newMail === this.newMail2 && (this.userData && this.newMail === this.userData.email);
        },
        matchPassword()
        {
            return this.confirmPassword.length <= 0 || this.newPassword === this.confirmPassword;
        },
        isValidEmail()
        {
            return this.newMail.length > 0 && (this.newMail === this.newMail2) && (this.userData && this.newMail !== this.userData.email);
        },
        isValidPassword()
        {
            return this.oldPassword.length > 0 && this.newPassword.length > 0 && (this.newPassword === this.confirmPassword);
        },
        isChangeMailRouteEnabled()
        {
            // return this.enabledRoutes.includes("all") || this.enabledRoutes.includes("change-mail");
            return true;
        },
        currentPriceType()
        {
            if (this.noSwitchCountry && this.userData.classId === 2) {
                return 'b2c';
            }

            return this.stateCurrentPriceType;
        },
        ...mapState({
            billingAddressId: state => state.address.billingAddressId,
            billingAddress: state => state.address.billingAddress,
            stateCurrentPriceType: state => state.localization.currentPriceType,
            noSwitchCountry: state => state.localization.noSwitchCountry,
        })
    },

    methods: {

        /**
         * Open the change mail modal
         */
        showChangeAccountEmail()
        {
            this.accountEmailModal.show();
        },

        /**
         * Open the change password modal
         */
        showChangeAccountPassword()
        {
            this.accountPasswordModal.show();
        },

        /**
         * Open the change customer type modal
         */
        showChangeCustomerType()
        {
            this.$data._billingAddress = {...this.billingAddress};

            if(this.currentPriceType === "b2b")
            {
                this.$data._billingAddress.name1 = "";
                this.$data._billingAddress.vatNumber = "";
                this.$data._billingAddress.gender = "male";
            }
            else if(this.currentPriceType === "b2c")
            {
                this.$data._billingAddress.gender = "company";
            }

            this.accountCustomerTypeModal.show();
        },

        /**
         * Checks the new password to see if it meets the password requirements
         */
        validatePassword()
        {
            ValidationService.validate(this.$refs.passwordFormControl)
                .done(() =>
                {
                    this.saveAccountPassword();
                })
                .fail(invalidFields =>
                {
                    ValidationService.markInvalidFields(invalidFields, "error");
                    NotificationService.error(
                        TranslationService.translate("Ceres::Template.resetPwInvalidPassword")
                    ).closeAfter(5000);
                    this.$refs.passwordHint.showPopper();
                });
        },

        validateCustomerType()
        {
            ValidationService.validate(this.$refs.typeFormControl)
                .done(() =>
                {
                    this.saveCustomerType();
                })
                .fail(invalidFields =>
                {
                    ValidationService.markInvalidFields(invalidFields, "error");
                    const invalidFieldNames = this.getInvalidFieldNames(invalidFields);
                    NotificationService.error(
                        this.$translate("Ceres::Template.checkoutCheckAddressFormFields", { fields: invalidFieldNames.join(", ") })
                    );
                    this.$refs.passwordHint.showPopper();
                });
        },

        getInvalidFieldNames(invalidFields = [])
        {
            const fieldNames = [];

            for (const field of invalidFields)
            {
                let fieldName = field.lastElementChild.innerHTML.trim();

                fieldName = fieldName.slice(-1) === "*" ? fieldName.slice(0, fieldName.length - 1) : fieldName;
                fieldNames.push(fieldName);
            }

            return fieldNames;
        },

        /**
         * Save the new password
         */
        saveAccountPassword()
        {
            if (this.isValidPassword)
            {
                this.isLoading = true;
                APIService.post("/rest/io/customer/password", {
                    oldPassword: this.oldPassword, password: this.newPassword, password2: this.confirmPassword
                })
                .done(response =>
                {
                    this.clearFieldsAndClose();
                    NotificationService.success(
                        TranslationService.translate("Ceres::Template.myAccountChangePasswordSuccessful")
                    ).closeAfter(3000);
                })
                .fail(response =>
                {
                    NotificationService.error(
                        TranslationService.translate("Ceres::Template.myAccountChangePasswordFailed")
                    ).closeAfter(5000);
                })
                .always(() =>
                {
                    this.isLoading = false;
                });
            }
        },
        /**
         * Save the new email
         */
        saveAccountEmail()
        {
            if (this.isValidEmail)
            {
                this.isLoading = true;
                APIService.post("/rest/io/customer/mail", { newMail: this.newMail, newMail2: this.newMail2 })
                    .done(response =>
                    {
                        this.clearFieldsAndClose();
                        NotificationService.success(
                            TranslationService.translate("Ceres::Template.myAccountChangeEmailConfirmationSent")
                        ).closeAfter(3000);
                    })
                    .fail((response, status) =>
                    {
                        let message = TranslationService.translate("Ceres::Template.myAccountChangeEmailFailed");

                        if (status === 400)
                        {
                            message = TranslationService.translate("Ceres::Template.regError");
                        }

                        NotificationService.error(message).closeAfter(5000);
                    })
                    .always(() =>
                    {
                        this.isLoading = false;
                    });
            }
        },

        /**
         * Save the customer type
         */
        saveCustomerType()
        {
            this.isLoading = true;

            // fallback if vatNumber is not required and field is undefined
            // if field is not send no customer class change is performed
            if(!this.requiredAddressFields.includes('billing_address.vatNumber') && isNullOrUndefined(this.$data._billingAddress.vatNumber)) {
                this.$data._billingAddress.vatNumber = '';
            }

            this.syncOptionTypesAddressData();

            this.$store.dispatch("updateAddress", {
                address: this.$data._billingAddress,
                addressType: "1"
            })
            .then(
                () =>
                {
                    this.clearFieldsAndClose();

                    NotificationService.success(
                        TranslationService.translate("OD3dprimaV2::Template.changeCustomerTypeSuccess")
                    ).closeAfter(3000);

                    this.isLoading = false;
                },
                error =>
                {
                    if(!isNullOrUndefined(error))
                    {
                        if (error.validation_errors)
                        {
                            this.handleServerValidationErrors(error.validation_errors);
                        }
                        else if (error.error)
                        {
                            this.handleServerError(error.error);
                        }
                    }

                    this.isLoading = false;
                }
            );
        },

        /**
         * Clear the password fields in the modal
         */
        clearFields()
        {
            this.oldPassword = "";
            this.newPassword = "";
            this.confirmPassword = "";
            this.newMail = "";
            this.newMail2 = "";
        },

        /**
         * Clear the fields and close the modal
         */
        clearFieldsAndClose()
        {
            if (this.accountEmailModal)
            {
                this.accountEmailModal.hide();
            }

            this.accountPasswordModal.hide();
            this.accountCustomerTypeModal.hide();
            this.clearFields();
        },

        handleServerValidationErrors(validationErrors)
        {
            ValidationService.markFailedValidationFields(this.$refs.typeFormControl, validationErrors);

            let errorMessage = "";

            for (const value of Object.values(validationErrors))
            {
                errorMessage += value + "<br>";
            }

            NotificationService.error(errorMessage);
        },

        handleServerError(error)
        {
            if (error.code === 11)
            {
                NotificationService.error({code: error.code, message: ""});
                window.location.reload();
            }
            else if ([210, 211].indexOf(error.code) !== -1)
            {
                NotificationService.error({code: error.code, message: error.message});
            }
            else this._handleValidationErrors(error);
        },

        syncOptionTypesAddressData()
        {
            if (!isNullOrUndefined(this.$data._billingAddress.options))
            {
                for (const optionType of this.$data._billingAddress.options)
                {
                    if(optionType.typeId === 1)
                    {
                        if (!isNullOrUndefined(this.$data._billingAddress.vatNumber) && this.$data._billingAddress.vatNumber !== optionType.value)
                        {
                            optionType.value = this.$data._billingAddress.vatNumber;
                        }
                    }
                }
            }
        },

        reload()
        {
            this.$nextTick(() =>
            {
                setTimeout(() =>
                {
                    location.reload()
                }, 500)
            })
        }
    }
}
</script>
